import React, { useEffect, useState } from "react";
import YearCalendar from "../../shared/YearlyCalendar";
import {
  SlIcon,
  SlSelect,
  SlOption,
} from "@shoelace-style/shoelace/dist/react";
import API from "../../services/api";
import { useSelector } from "react-redux";
import TableLoader from "../../shared/TableLoader";
import NoDataFound from "../../shared/NoDataFound";
import * as XLSX from "xlsx";
import {getBrandOptions, toLakhs} from '../../utils/constants';
import ScrollContainer from "react-indiana-drag-scroll";

function MonthwisePlan() {
  const [downloadLoader, setDownloadLoader] = useState(false);
  const [data, setData] = useState([]);
  const [loader, setLoader] = useState(false);
  const selectedYear = useSelector((state) => state.Head.selectedYear);
  const fyear = new Date(selectedYear).getFullYear();
  const year = new Date(selectedYear).getFullYear() % 100;
  const [newsPapers, setNewsPapers] = useState([]);
  const [selectedNewspaper, setSelectedNewspaper] = useState("Eenadu");
  const [categories, setCategories] = useState([]);
  const [selectedType, setSelectedType] = useState("all");
  const fetchdata = async () => {
    setLoader(true);
    try {
      let res = await API({
        url: "/plansummary/monthwise",
        method: "POST",
        responseType: "json",
        data: {
          year: selectedYear,
          newsPaper: selectedNewspaper,
          type:selectedType
        },
      });
      if (res.code === 200) {
        setData(res.data);
        if(res.data.userType !== -1){
          setSelectedType(`${res.data.userType}`)
        }
      }
    } catch (error) {
    } finally {
      setLoader(false);
    }
  };
  const fetchNewsPapers = async () => {
    try {
      let res = await API({
        url: "/market/newspapers",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        const newspapers = res.data.filter(
          (paper) => paper?.name !== "Way2news"
        );
        setNewsPapers([...newspapers]);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const fetchCategories = async () => {
    try {
      let res = await API({
        url: "/plansummary/categories",
        method: "POST",
        responseType: "json",
        data: {},
      });
      if (res.code === 200) {
        setCategories(res.data);
      }
    } catch (error) {
      console.error(error);
    }
  };
  const getdownloadData = () => {
    setDownloadLoader(true);
    try {
      let headers = ["All Revenues are in Lakhs"];
      for (let index = 0; index < 12; index++) {
        const date = new Date(2024, index, 1);
        const month = date.toLocaleString("default", { month: "short" });
        headers.push(`${month}-${year}`);
      }

      let rows = [];
      rows.push(headers);
      rows.push([`W2N-FY${year}`]);
      let accountsAdvertised = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return record[0]?.[`Way2news_count_${fyear}`] || 0;
      });

      let noOfInsertions = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return record[0]?.[`Way2news_insertions_${fyear}`] || 0;
      });

      let revenues = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return record[0]?.[`Way2news_revenue_${fyear}`] || 0;
      });

      let revenuesPerInsertion = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return (
          record[0]?.[`Way2news_revenue_${fyear}`] /
            record[0]?.[`Way2news_insertions_${fyear}`] || 0
        ).toFixed(2);
      });
      rows.push(["Accounts Advertised", ...accountsAdvertised]);
      rows.push(["No of Insertions", ...noOfInsertions]);
      rows.push(["Revenues", ...revenues]);
      rows.push(["Revenue Per Insertion", ...revenuesPerInsertion]);

      rows.push([`W2N-FY${year - 1}`]);
      accountsAdvertised = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`Way2news_count_${fyear - 2}`] || 0
          : record[0]?.[`Way2news_count_${fyear - 1}`] || 0;
      });

      noOfInsertions = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`Way2news_insertions_${fyear - 2}`] || 0
          : record[0]?.[`Way2news_insertions_${fyear - 1}`] || 0;
      });

      revenues = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`Way2news_revenue_${fyear - 2}`] || 0
          : record[0]?.[`Way2news_revenue_${fyear - 1}`] || 0;
      });

      revenuesPerInsertion = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? (
              record[0]?.[`Way2news_revenue_${fyear - 2}`] /
                record[0]?.[`Way2news_insertions_${fyear - 2}`] || 0
            ).toFixed(2)
          : (
              record[0]?.[`Way2news_revenue_${fyear - 1}`] /
                record[0]?.[`Way2news_insertions_${fyear - 1}`] || 0
            ).toFixed(2);
      });
      rows.push(["Accounts Advertised", ...accountsAdvertised]);
      rows.push(["No of Insertions", ...noOfInsertions]);
      rows.push(["Revenues", ...revenues]);
      rows.push(["Revenue Per Insertion", ...revenuesPerInsertion]);

      rows.push([`${selectedNewspaper}-FY${year}`]);
      accountsAdvertised = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`${selectedNewspaper}_count_${fyear - 1}`] || 0
          : record[0]?.[`${selectedNewspaper}_count_${fyear}`] || 0;
      });

      noOfInsertions = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`${selectedNewspaper}_insertions_${fyear - 1}`] || 0
          : record[0]?.[`${selectedNewspaper}_insertions_${fyear}`] || 0;
      });

      revenues = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`${selectedNewspaper}_revenue_${fyear - 1}`] || 0
          : record[0]?.[`${selectedNewspaper}_revenue_${fyear}`] || 0;
      });

      revenuesPerInsertion = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? (
              record[0]?.[`${selectedNewspaper}_revenue_${fyear - 1}`] /
                record[0]?.[`${selectedNewspaper}_insertions_${fyear - 1}`] || 0
            ).toFixed(2)
          : (
              record[0]?.[`${selectedNewspaper}_revenue_${fyear}`] /
                record[0]?.[`${selectedNewspaper}_insertions_${fyear}`] || 0
            ).toFixed(2);
      });
      rows.push(["Accounts Advertised", ...accountsAdvertised]);
      rows.push(["No of Insertions", ...noOfInsertions]);
      rows.push(["Revenues", ...revenues]);
      rows.push(["Revenue Per Insertion", ...revenuesPerInsertion]);
      rows.push([`W2N-FY${year} Category Wise`]);

      rows.push([`${selectedNewspaper}-FY${year - 1}`]);
      accountsAdvertised = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`${selectedNewspaper}_count_${fyear - 2}`] || 0
          : record[0]?.[`${selectedNewspaper}_count_${fyear - 1}`] || 0;
      });

      noOfInsertions = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`${selectedNewspaper}_insertions_${fyear - 2}`] || 0
          : record[0]?.[`${selectedNewspaper}_insertions_${fyear - 1}`] || 0;
      });

      revenues = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? record[0]?.[`${selectedNewspaper}_revenue_${fyear - 2}`] || 0
          : record[0]?.[`${selectedNewspaper}_revenue_${fyear - 1}`] || 0;
      });

      revenuesPerInsertion = Array.from({ length: 12 }).map((_, index) => {
        const record = getRecord(index + 1);
        return index + 1 === 12
          ? (
              record[0]?.[`${selectedNewspaper}_revenue_${fyear - 2}`] /
                record[0]?.[`${selectedNewspaper}_insertions_${fyear - 2}`] || 0
            ).toFixed(2)
          : (
              record[0]?.[`${selectedNewspaper}_revenue_${fyear - 1}`] /
                record[0]?.[`${selectedNewspaper}_insertions_${fyear - 1}`] || 0
            ).toFixed(2);
      });
      rows.push(["Accounts Advertised", ...accountsAdvertised]);
      rows.push(["No of Insertions", ...noOfInsertions]);
      rows.push(["Revenues", ...revenues]);
      rows.push(["Revenue Per Insertion", ...revenuesPerInsertion]);
      rows.push([`W2N-FY${year} Category Wise`]);
      for (const category of categories) {
        rows.push([category.category_name]);
        const accountsAdvertised = Array.from({ length: 12 }).map(
          (_, index) => {
            const record = getCategoryRecord(category.category_name, index + 1);
            return record[0]?.[`Way2news_brands_${fyear}`] || 0;
          }
        );

        const noOfInsertions = Array.from({ length: 12 }).map((_, index) => {
          const record = getCategoryRecord(category.category_name, index + 1);
          return record[0]?.[`Way2news_insertions_${fyear}`] || 0;
        });

        const revenues = Array.from({ length: 12 }).map((_, index) => {
          const record = getCategoryRecord(category.category_name, index + 1);
          return record[0]?.[`Way2news_revenue_${fyear}`] || 0;
        });

        const revenuesPerInsertion = Array.from({ length: 12 }).map(
          (_, index) => {
            const record = getCategoryRecord(category.category_name, index + 1);
            return (
              record[0]?.[`Way2news_revenue_${fyear}`] /
                record[0]?.[`Way2news_insertions_${fyear}`] || 0
            ).toFixed(2);
          }
        );
        rows.push(["Accounts Advertised", ...accountsAdvertised]);
        rows.push(["No of Insertions", ...noOfInsertions]);
        rows.push(["Revenues", ...revenues]);
        rows.push(["Revenue Per Insertion", ...revenuesPerInsertion]);
      }
      const worksheetData = [...rows];

      // Create worksheet and workbook
      const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);

      // Merge cells for the first header row
      const merges = [];
      merges.push({s:{r:1, c:0}, e:{r:1, c:12}});
      merges.push({s:{r:6, c:0}, e:{r:6, c:12}});
      merges.push({s:{r:11, c:0}, e:{r:11, c:12}});
      merges.push({s:{r:16, c:0}, e:{r:16, c:12}});
      let currrow = 17
      for(const category of categories){
        merges.push({s:{r:currrow, c:0}, e:{r:currrow, c:12}});
        currrow += 5
      }
    worksheet["!merges"] = merges;
    const workbook = XLSX.utils.book_new();
        XLSX.utils.book_append_sheet(
          workbook,
          worksheet,
          `FY${year} Monthwise Plan`
        );

        // Write the file
        XLSX.writeFile(workbook, `FY${year} monthwise plan.xlsx`);


    } catch (error) {
      console.error(error, "Download Error in Monthwise Plan");
    } finally {
      setDownloadLoader(false);
    }
  };

  useEffect(() => {
    fetchNewsPapers();
    fetchCategories();
  }, []);
  useEffect(() => {
    fetchdata();
  }, [selectedYear, selectedNewspaper,selectedType]);

  const getCategoryRecord = (category, month) => {
    try {
      return data?.category_wise?.filter(
        (item) => item.category === category && parseInt(item.month) === month
      );
    } catch (error) {
      console.error(error);
    }
  };

  const getRecord = (month) => {
    try {
      return data?.year_wise?.filter((item) => parseInt(item.month) === month);
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <>
      <div className="d-flex gap-3 justify-end items-center my-2">
      <SlSelect size="small" value={selectedType} label="Team" onSlChange={(e) => {setSelectedType(e.target.value)}}>
          {data?.userType === -1 ? <SlOption value='all'>All</SlOption> : null}
          {getBrandOptions(data?.userType, localStorage.getItem('email'))?.map((type) => (
            <SlOption key={type.value} value={type.value}>{type.label}</SlOption>
          ))}
        </SlSelect>
        <SlSelect
          placeholder="NewsPaper"
          value={selectedNewspaper}
          onSlChange={(e) => setSelectedNewspaper(e.target.value)}
        >
          {newsPapers.map((item) => (
            <SlOption key={item.name} value={item.name}>
              {item.name}
            </SlOption>
          ))}
        </SlSelect>
        <YearCalendar startYear={2023} endYear={2100}></YearCalendar>
        {downloadLoader ? (
          <div className="spinner-border text-primary" role="status">
            <span className="visually-hidden">Loading...</span>
          </div>
        ) : (
          <div
            className="w-7 h-7 bg-slate-100 hover:text-cyan-500 rounded-lg cursor-pointer items-center justify-center hover:bg-slate-150 flex"
            onClick={getdownloadData}
          >
            <sl-tooltip content="Download" placement="top">
              <SlIcon library="lucide" name="download" />
            </sl-tooltip>
          </div>
        )}
      </div>
      <ScrollContainer>
      <table className="table table-bordered">
        <thead>
          <tr>
            <th>All Revenues are in Lakhs</th>
            {Array.from({ length: 12 }).map((_, index) => {
              const date = new Date(2024, index, 1);
              const month = date.toLocaleString("default", { month: "short" });
              return <th key={index}>{`${month}-${year}`}</th>;
            })}
          </tr>
        </thead>
        {!loader && Object.keys(data)?.length > 0 ? (
          <tbody>
            <tr>
              <th colSpan={13}>W2N-FY{year}</th>
            </tr>
            <tr>
              <th>{"Accounts Advertised"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>{record[0]?.[`Way2news_count_${fyear}`]}</td>
                );
              })}
            </tr>
            <tr>
              <th>{"No of Insertions"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>
                    {record[0]?.[`Way2news_insertions_${fyear}`]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>{toLakhs(record[0]?.[`Way2news_revenue_${fyear}`])}</td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues per Insertion"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>
                    {toLakhs(
                      record[0]?.[`Way2news_revenue_${fyear}`] /
                        record[0]?.[`Way2news_insertions_${fyear}`] || 0
                    )}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th colSpan={13}>W2N-FY{year - 1}</th>
            </tr>
            <tr>
              <th>{"Accounts Advertised"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? record[0]?.[`Way2news_count_${fyear - 2}`]
                      : record[0]?.[`Way2news_count_${fyear - 1}`]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"No of Insertions"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? record[0]?.[`Way2news_insertions_${fyear - 2}`]
                      : record[0]?.[`Way2news_insertions_${fyear - 1}`]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? toLakhs(record[0]?.[`Way2news_revenue_${fyear - 2}`])
                      : toLakhs(record[0]?.[`Way2news_revenue_${fyear - 1}`])}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues per Insertion"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? 
                          toLakhs(record[0]?.[`Way2news_revenue_${fyear - 2}`] /
                            record[0]?.[`Way2news_insertions_${fyear - 2}`]
                        )
                      : toLakhs(
                          record[0]?.[`Way2news_revenue_${fyear - 1}`] /
                            record[0]?.[`Way2news_insertions_${fyear - 1}`]
                        )}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th colSpan={13}>
                {selectedNewspaper}-FY{year}
              </th>
            </tr>
            <tr>
              <th>{"Accounts Advertised"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? record[0]?.[`${selectedNewspaper}_count_${fyear - 1}`]
                      : record[0]?.[`${selectedNewspaper}_count_${fyear}`]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"No of Insertions"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? record[0]?.[
                          `${selectedNewspaper}_insertions_${fyear - 1}`
                        ]
                      : record[0]?.[
                          `${selectedNewspaper}_insertions_${fyear}`
                        ]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? toLakhs(record[0]?.[`${selectedNewspaper}_revenue_${fyear - 1}`])
                      : toLakhs(record[0]?.[
                          `${selectedNewspaper}_revenue_${fyear}`
                        ])}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues per Insertion"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? toLakhs(
                          record[0]?.[
                            `${selectedNewspaper}_revenue_${fyear - 1}`
                          ] /
                            record[0]?.[
                              `${selectedNewspaper}_insertions_${fyear - 1}`
                            ]
                        )
                      : toLakhs(
                          record[0]?.[
                            `${selectedNewspaper}_revenue_${fyear}`
                          ] /
                            record[0]?.[
                              `${selectedNewspaper}_insertions_${fyear}`
                            ]
                        )}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th colSpan={13}>
                {selectedNewspaper}-FY{year - 1}
              </th>
            </tr>
            <tr>
              <th>{"Accounts Advertised"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? record[0]?.[`${selectedNewspaper}_count_${fyear - 2}`]
                      : record[0]?.[`${selectedNewspaper}_count_${fyear - 1}`]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"No of Insertions"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? record[0]?.[
                          `${selectedNewspaper}_insertions_${fyear - 2}`
                        ]
                      : record[0]?.[
                          `${selectedNewspaper}_insertions_${fyear - 1}`
                        ]}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1); // Fetch the record for the current month
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? toLakhs(record[0]?.[`${selectedNewspaper}_revenue_${fyear - 2}`])
                      : toLakhs(record[0]?.[
                          `${selectedNewspaper}_revenue_${fyear - 1}`
                        ])}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th>{"Revenues per Insertion"}</th>
              {Array.from({ length: 12 }).map((_, index) => {
                const record = getRecord(index + 1);
                return (
                  <td key={index}>
                    {index + 1 === 12
                      ? toLakhs(
                          record[0]?.[
                            `${selectedNewspaper}_revenue_${fyear - 2}`
                          ] /
                            record[0]?.[
                              `${selectedNewspaper}_insertions_${fyear - 2}`
                            ]
                        )
                      : toLakhs(
                          record[0]?.[
                            `${selectedNewspaper}_revenue_${fyear - 1}`
                          ] /
                            record[0]?.[
                              `${selectedNewspaper}_insertions_${fyear - 1}`
                            ]
                        )}
                  </td>
                );
              })}
            </tr>
            <tr>
              <th colSpan={13}>W2N-FY{year} Category Wise</th>
            </tr>
            {categories.map((category, index) => {
              return (
                <>
                  <tr key={index}>
                    <th colSpan={13}>{category.category_name}</th>
                  </tr>
                  <tr key={index}>
                    <th>{"Accounts Advertised"}</th>
                    {Array.from({ length: 12 }).map((_, index) => {
                      const record = getCategoryRecord(
                        category.category_name,
                        index + 1
                      );
                      return (
                        <td key={index}>
                          {record[0]?.[`Way2news_brands_${fyear}`]}
                        </td>
                      );
                    })}
                  </tr>
                  <tr key={index}>
                    <th>{"No of Insertions"}</th>
                    {Array.from({ length: 12 }).map((_, index) => {
                      const record = getCategoryRecord(
                        category.category_name,
                        index + 1
                      );
                      return (
                        <td key={index}>
                          {record[0]?.[`Way2news_insertions_${fyear}`]}
                        </td>
                      );
                    })}
                  </tr>
                  <tr key={index}>
                    <th>{"Revenues"}</th>
                    {Array.from({ length: 12 }).map((_, index) => {
                      const record = getCategoryRecord(
                        category.category_name,
                        index + 1
                      );
                      return (
                        <td key={index}>
                          {toLakhs(record[0]?.[`Way2news_revenue_${fyear}`])}
                        </td>
                      );
                    })}
                  </tr>
                  <tr key={index}>
                    <th>{"Revenues per Insertion"}</th>
                    {Array.from({ length: 12 }).map((_, index) => {
                      const record = getCategoryRecord(
                        category.category_name,
                        index + 1
                      );
                      return (
                        <td key={index}>
                          {toLakhs(
                            record[0]?.[`Way2news_revenue_${fyear}`] /
                              record[0]?.[`Way2news_insertions_${fyear}`] || 0
                          )}
                        </td>
                      );
                    })}
                  </tr>
                </>
              );
            })}
          </tbody>
        ) : loader ? (
          <TableLoader colspan={13} />
        ) : (
          <NoDataFound colspan={13} />
        )}
      </table>
      </ScrollContainer>
    </>
  );
}

export default MonthwisePlan;
